// Polyfill for Node.js globals used by aws-appsync-subscription-link
(window as any).global = window;
(window as any).process = { env: {} };
